/* eslint-disable no-param-reassign */
import axios from 'axios'
import {
	getAuthTokenInStorage,
	removeAuthTokenInStorage,
	removeUserInfoInStorage,
} from './auth'

// eslint-disable-next-line no-undef
const URL = process.env.REACT_APP_BASE_URL

const api = axios.create({
	headers: { 'ngrok-skip-browser-warning': true },
	baseURL: URL,
})

api.interceptors.request.use(async (config) => {
	const token = getAuthTokenInStorage()
	if (token && config.headers) {
		config.headers.Authorization = `Bearer ${token}`
	}
	return config
})

api.interceptors.response.use(undefined, async (error) => {
	// Only treat a 401 as "session expired" for our own auth. A 401 coming from a
	// sub-resource (e.g. saving an invalid Asaas API key) must NOT log the user out.
	const requestUrl: string = error.config?.url ?? ''
	const isAsaasRequest = requestUrl.includes('/asaas')
	if (error.response?.status === 401 && !isAsaasRequest) {
		removeAuthTokenInStorage()
		removeUserInfoInStorage()
		window.location.href = '/'
	}
	if (axios.isAxiosError(error) && error.response?.data) {
		throw error.response.data
	}
	throw error
})

export default api
